import { GenericTable } from "@shared/components/GenericTable";
import { TableAction } from "@shared/types/table";
import { Badge } from "@shared/ui/badge";
import { Checkbox } from "@shared/ui/checkbox";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMeterReadingPendingValidation } from "../../hooks";
import { toast } from "@shared/ui/use-toast";
import { usePutPassExemptReading } from "@features/mx/validations/hooks";

interface PendingValidationSubTabProps {
  meterReadingPendingValidationList?: any;
}

export const PendingValidationSubTab: React.FC<PendingValidationSubTabProps> = ({meterReadingPendingValidationList}) => {
  const [selectedPendingValidation, setSelectedPendingValidation] = useState<
    string[]
  >([]);
  const navigate = useNavigate();
  // const passReading = usePutPassExemptReading(readingId, meterRunId);


  //frunction to pass the pendding reading
    // const handlePassReading = () => {
    //   const payload = {
    //     rule_status: 1,
    //   };
    //   passReading.mutate(payload, {
    //     onSuccess: () => {
      
    //       toast({
    //         variant: "default",
    //         title: "Success",
    //         description: "Reading passed successfully",
    //       });
    //     },
    //   });
    // };

  const renderIssueBadge = (issue: string) => {
    switch (issue) {
      case "Low Consumption":
        return (
          <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-200">
            {issue}
          </Badge>
        );
      case "Meter Reading Out of Trend":
        return (
          <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-200">
            {issue}
          </Badge>
        );
      case "Reading Date Mismatch":
        return (
          <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-200">
            {issue}
          </Badge>
        );
      case "Manual Reading Not Verified":
        return (
          <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-200">
            {issue}
          </Badge>
        );
      default:
        return <Badge variant="outline">{issue}</Badge>;
    }
  };
  const [currentPage, setCurrentPage] = useState(1);

  const validationTableColumns = [
    // {
    //   key: "selection",
    //   header: "",
    //   width: "w-[50px]",
    //   render: (value: any, row: any) => (
    //     <Checkbox
    //       checked={selectedPendingValidation.includes(row.id)}
    //       onCheckedChange={(checked) => {
    //         if (checked) {
    //           setSelectedPendingValidation((prev) => [...prev, row.id]);
    //         } else {
    //           setSelectedPendingValidation((prev) =>
    //             prev.filter((id) => id !== row.id)
    //           );
    //         }
    //       }}
    //     />
    //   ),
    // },
    {
      key: "meterNumber",
      header: "Meter No",
    },
    {
      key: "consumerName",
      header: "Consumer",
    },
    {
      key: "consumerNumber",
      header: "Account",
    },
    {
      key: "meterType",
      header: "Meter Type",
    },
    {
      key: "service",
      header: "Service",
    },
    {
      key: "lastReading",
      header: "Last Reading",
      width: "text-right",
    },
    {
      key: "currentReading",
      header: "Current Reading",
      width: "text-right",
    },
    {
      key: "consumption",
      header: "Consumption",
      width: "text-right",
    },
    {
      key: "issue",
      header: "Issue",
      render: (value: any, row: any) => {
        return row.issue ? renderIssueBadge(row.issue) : null;
      },
    },
  ];
  const validationTableActions: TableAction<any>[] = [
    {
    label: "View",
    onClick: (row: any) => {
      const runId = row.runId; // make sure your API returns runId
      const readingId = row.readingId; // make sure your API returns readingId

      if (!runId || !readingId) {
        console.error("Missing runId or readingId", row);
        return;
      }

      navigate(
        `/mx/meter-validation/photometer-validation/${runId}?tab=view&page=1&readingId=${readingId}`
      );
    },
  },
    {
      label: "Pass",
      onClick: (row: any) => {
        // Add your validate logic here
        console.log("Validate clicked for:", row);
      },
    },
     {
      label: "Exempt",
      onClick: (row: any) => {
        // Add your validate logic here
        console.log("Validate clicked for:", row);
      },
    },

  ];
  const itemsPerPage = 50;

  const params = useParams();
  // const { data: meterReadingPendingValidationList } =
  //   useMeterReadingPendingValidation(params?.id, currentPage);
  return (
    <div className="p-4 bg-background">
      <div className="mb-4">
        <h3 className="text-xl font-bold">Pending Validation</h3>
        <p className="text-muted-foreground text-sm">
          Readings that require validation
        </p>
      </div>

      {/* <div className="flex justify-between mb-4">
        <div className="flex items-center">
          <label htmlFor="select-all-validation" className="ml-2 text-sm">
            Select All
          </label>
        </div>
        <div className="flex gap-2"></div>
      </div> */}

      <div className="border rounded-md overflow-auto max-h-[400px]">
        <GenericTable
          data={meterReadingPendingValidationList?.results ?? []}
          columns={validationTableColumns}
          rowKey="id"
          actions={validationTableActions}
          actionsType="buttons"
          emptyMessage="No pending validations found"
          loading={false}
          pagination={{
            currentPage,
            totalPages: Math.ceil(
              (meterReadingPendingValidationList?.count || 0) / itemsPerPage
            ),
            totalItems: meterReadingPendingValidationList?.count || 0,
            itemsPerPage,
            startItem: (currentPage - 1) * itemsPerPage + 1,
            endItem: Math.min(
              currentPage * itemsPerPage,
              meterReadingPendingValidationList?.count || 0
            ),
          }}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
};
